/**
 * UNCS - mega menu interakce
 *   - hover/focus L1 položky s podseznamy přepne viditelný L2 řádek
 *   - L1 odkazy zůstávají klikatelné (navigují na danou kolekci)
 */
(function () {
  "use strict";

  var l2Row = document.querySelector(".uncs-l2-row");
  if (!l2Row) return;

  var lists = l2Row.querySelectorAll(".uncs-l2-list");
  if (lists.length === 0) return;

  var l1Items = document.querySelectorAll(".uncs-l1-item[data-has-children='true']");

  function activate(handle) {
    if (!handle) return;
    l2Row.setAttribute("data-active-handle", handle);
    lists.forEach(function (ul) {
      if (ul.dataset.parentHandle === handle) {
        ul.removeAttribute("hidden");
      } else {
        ul.setAttribute("hidden", "");
      }
    });
    document.querySelectorAll(".uncs-l1-item").forEach(function (li) {
      li.classList.toggle("is-active", li.dataset.handle === handle);
    });
  }

  var initialList = l2Row.querySelector(".uncs-l2-list:not([hidden])");
  if (initialList) activate(initialList.dataset.parentHandle);

  l1Items.forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      activate(item.dataset.handle);
    });
    item.addEventListener("focusin", function () {
      activate(item.dataset.handle);
    });
  });
})();
